import axios from "axios";
import GetServerAddress from "../../../../functions/GetServerAddress";

export async function Get_Count_Of_SEF_Colors(setData, logout) {
  try {
    const response = await axios.post(
      GetServerAddress() + "api/staff/Get_Count_Of_SEF_Colors",
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Token")}`, // Include the JWT token in the request headers
          username: localStorage.getItem("Username"),
          activitylog: "No",
        },
      }
    );
    console.log("Response Data COLORS: ", response);

    // Check for specific server response indicating an invalid auth token
    if (response.data.status === 403 || response.data.status === 401) {
      logout();
      return; // Stop further execution in case of invalid auth token
    }
    setData(response.data.data);

    //Catch Errors
  } catch (error) {
    console.error("Error fetching data: ", error);
    window.alert(
      "Error Getting data, please speak to Admin if this issue persists: ",
      error
    );
  }
}
